import { ContractXanaliaDex } from 'blockchain/instance'
import { SupportedChainId, SupportedChains } from 'constants/chain'
import { getAddress } from 'wallet/ether'

export function setWhitelistAddress(
  type: SupportedChains | SupportedChainId,
  address: Array<string>,
  status: Array<boolean>
): Promise<[any, any]> {
  return new Promise(async (resolve, reject) => {
    try {
      const contract = await ContractXanaliaDex(type)
      if (typeof contract === 'undefined' || !(await getAddress())) {
        resolve([undefined, undefined])
      }

      const result = await contract.setWhitelistAddress(address, status)
      resolve([result, undefined])
    } catch (error) {
      reject([undefined, error])
    }
  })
}

const xanaliaDex = { setWhitelistAddress }

export default xanaliaDex
